import { useEffect } from 'react';

const strip = (title: string, prefix: string) => (title.startsWith(prefix) ? title.slice(prefix.length) : title);

/**
 * Держит приставку в заголовке вкладки, пока `prefix` задан: страницы меняют `<title>` сами (React 19 поднимает их
 * в `head`), поэтому приставка возвращается после каждой смены. `null` снимает её.
 */
export function useDocumentTitlePrefix(prefix: string | null): void {
    useEffect(() => {
        if (!prefix) return undefined;
        const apply = () => {
            if (!document.title.startsWith(prefix)) document.title = prefix + document.title;
        };
        apply();
        const observer = new MutationObserver(apply);
        observer.observe(document.head, { subtree: true, childList: true, characterData: true });
        return () => {
            observer.disconnect();
            document.title = strip(document.title, prefix);
        };
    }, [prefix]);
}
